import * as React from 'react';

function SvgItaly(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 36 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 20.789h11.846V.058H0v20.73z"
        fill="#009246"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.846 20.789h11.845V.058H11.846v20.73z"
        fill="#F1F2F1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.691 20.789H35.54V.058H23.69v20.73z"
        fill="#CE2B37"
      />
    </svg>
  );
}

export default SvgItaly;
